module.exports = __webpack_public_path__ + "img/draw-check-mark.53f02097.svg";